import app from 'firebase/app';
import 'firebase/auth';

import axios from 'axios';
import { config } from './config';
import { getCookie } from '../../utils';

const SERVER_BASE_URL = 'https://app.vote-chain.com';
const SERVER_BASE_URL_LOCAL = 'http://localhost:8080';

const headers = { 'Content-Type' : 'application/json' }

const instance = axios.create({
  baseURL: SERVER_BASE_URL,
  withCredentials: true,
  headers,
});

function axiosInstance() {
  instance.defaults.headers = {
    'Content-Type' : 'application/json',
    'token': getCookie('token'),
  }

  return instance;
}

export class Firebase {

  isEmailUsed(email) {
    return axiosInstance().get(`/users/${email}`)
      .then(response => response.data)
      .catch(this.catchAxios);
  }

  getProfile() {
    return axiosInstance().get('/users/getProfile')
      .then(response => response.data)
      .catch(this.catchAxios);
  }

  register(email, password) {
    return axiosInstance().post('/users/registerWithMail', { email, password })
      .then(response => response.data)
      .catch(this.catchAxios);
  }

  login(email, password) {
    return axiosInstance().post('/users/signInWithEmail', { email, password })
      .then(response => response.data)
      .catch(this.catchAxios);
  }

  refreshUserToken(refreshToken) {
    return axiosInstance().post('/users/refreshUserToken', { refreshToken })
      .then(response => response.data)
      .catch(this.catchAxios);
  }

  loginWithGoogle() {
    if (!app.apps.length) {
      app.initializeApp(config);
    }

    const provider = new app.auth.GoogleAuthProvider();

    return app.auth().signInWithRedirect(provider);
  }

  handleGoogleLogin() {
    if (!app.apps.length) {
      app.initializeApp(config);
    }

    return app.auth().getRedirectResult()
      .then(response => response.credential.accessToken)
      .then(token => axiosInstance().post('/users/loginWithGoogle', { token }))
      .then(response => {
        sessionStorage.clear();
        return response.data;
      })
      .catch(this.catchAxios);
  }

  getPoll(id) {
    return axiosInstance().get(`/poll/${id}`)
      .then(response => response.data)
      .catch(this.catchAxios);
  }

  getUserPolls(userId) {
    return axiosInstance().get(`/user/${userId}/polls`)
      .then(response => response.data)
      .catch(this.catchAxios);
  }

  getPollTokens(id) {
    return axiosInstance().get(`/poll/${id}/tokens`)
      .then(response => response.data)
      .catch(this.catchAxios);
  }

  getPollToken(pollId, token) {
    return axiosInstance().get(`/poll/${pollId}/tokens/${token}`)
      .then(response => response.data)
      .catch(this.catchAxios);
  }

  savePoll(poll, id, userId) {
    return axiosInstance().post('/poll/save', { poll, id, userId })
      .then(response => response.data)
      .catch(this.catchAxios);
  }


  publishPoll(pollId, net) {
    return axiosInstance().post('/poll/publish', { pollId, net })
      .then(response => response.data)
      .catch(this.catchAxios);
  }

  unpublishPoll(pollId) {
    return axiosInstance().post('/poll/unpublish', { pollId })
      .then(response => response.data)
      .catch(this.catchAxios);
  }

  vote(pollId, token, answers) {
    return axiosInstance().post('/vote', { pollId, token, answers })
      .then(response => response.data)
      .catch(this.catchAxios);
  }

  catchAxios(err) {
    const errorMessage = err && err.response && err.response.data && err.response.data.message;
    throw new Error(errorMessage || err.message);
  }

}
